exports.onInitialClientRender = (_, options) => {
  var div = document.createElement('div');
  div.setAttribute('id', 'plugin-root');
  document.getElementsByTagName('body')[0].appendChild(div);

  var script = document.createElement('script');
  script.src = `${options.url}`;
  script.async = options.async || true;
  script.defer = options.defer || false;
  document.getElementsByTagName('body')[0].appendChild(script);
};
